/* ============================================================
   Judge.me Widget – Bewertungstexte kürzen ("Mehr lesen")
   ------------------------------------------------------------
   Branch : claude/Judge.me-Widget-Design-Anpassung
   Gehört zu: judgeme-widget.css (Abschnitt "TEXTKÜRZUNG")

   WAS DAS MACHT
   Bewertungen, die länger als MAX_LINES Zeilen sind – vor allem
   die von Amazon importierten, teils über 1400 Zeichen – werden
   auf MAX_LINES Zeilen gekürzt und mit "Mehr lesen" aufklappbar
   gemacht. Texte, die von sich aus kürzer sind, bleiben unberührt
   und bekommen KEINEN Link (er hätte nichts aufzuklappen).

   ------------------------------------------------------------
   WICHTIGSTE DESIGN-ENTSCHEIDUNG: FAIL-SAFE

   Das CSS kürzt NICHTS von allein. Gekürzt wird nur, was dieses
   Skript mit der Klasse .bonatea-clamp markiert.

   Folge: Läuft das Skript nicht – JS-Fehler, Theme-Update,
   geänderte Ladereihenfolge, Skript vergessen –, dann stehen die
   Bewertungen einfach vollständig da. Das ist der heutige
   Zustand, also kein Schaden.

   Andersherum wäre es gefährlich: kürzte das CSS von allein und
   das Skript fiele aus, stünden abgeschnittene Texte ohne jede
   Möglichkeit zum Aufklappen im Shop.

   ------------------------------------------------------------
   WARUM SO VIELE PRÜFZEITPUNKTE (bitte nicht "aufräumen")

   Judge.me baut das Widget asynchron auf, blendet es per Klasse
   erst ein, wenn es fertig ist, und tauscht beim Blättern die
   ganze Liste per AJAX aus. Eine einzige Messung beim Seitenstart
   reicht deshalb nicht: Wer misst, solange der Text noch nicht im
   Layout steht, misst Höhe 0 und hält jeden noch so langen Text
   für kurz.

   Genau dieser Fehler war in der ersten Fassung drin. Sie hat
   jeden Absatz vor dem Messen dauerhaft als "erledigt" markiert.
   Ergebnis: Auf manchen Produkten (z.B. Ingwer-Kurkuma) war
   Judge.me rechtzeitig fertig und alles stimmte, auf anderen
   (z.B. Minze Ingwer) kam die Messung zu früh und die langen
   Texte blieben ungekürzt stehen.

   Jetzt gilt: Gemessen wird nur, wenn der Text wirklich im Layout
   steht (siehe messbar()). Ist er es nicht, wird NICHTS gemerkt –
   der nächste Durchlauf versucht es erneut. Angestoßen wird das
   von MutationObserver (neue/getauschte Inhalte), ResizeObserver
   (Element wird sichtbar oder ändert seine Breite), load,
   fonts.ready (Webfont ändert den Umbruch), resize und
   orientationchange.

   ------------------------------------------------------------
   ALTERNATIVE OHNE CODE
   Judge.me kann das selbst: Feld widget_review_max_height in den
   App-Einstellungen (bei 3 Zeilen ca. 67 statt der früher
   notierten 56, die für 2,5 Zeilen standen). Wird der Wert dort
   gesetzt, kann diese Datei ersatzlos entfernt werden (und der
   Abschnitt TEXTKÜRZUNG im CSS gleich mit). Das wäre die
   wartungsärmere Lösung.
   ============================================================ */

(function () {
  'use strict';

  /* Ab wie vielen Zeilen gekürzt wird. Diese Zahl steht NUR hier –
     das CSS bekommt die fertige Höhe in Pixeln als Variable. */
  var MAX_LINES  = 3;

  var TOLERANZ   = 4;                   /* px Reserve gegen Rundungsfehler */
  var LABEL_MORE = 'Mehr lesen';
  var LABEL_LESS = 'Weniger anzeigen';

  var KLASSE_KURZ  = 'bonatea-clamp';
  var KLASSE_OFFEN = 'bonatea-clamp--open';
  var KLASSE_BTN   = 'bonatea-clamp-toggle';
  var KLASSE_FREI  = 'bonatea-clamp-frei';   /* Text bewusst ungekürzt */
  var KLASSE_FREMD = 'bonatea-fremd-toggle'; /* Judge.mes eigener Link */

  /* Texte, an denen ein fremder Aufklapp-Link erkannt wird. Judge.me
     bringt einen eigenen mit, sobald in der App
     widget_review_max_height gesetzt ist – dann standen zwei "Mehr
     lesen" untereinander. Wir übernehmen die Kürzung komplett und
     blenden den fremden Link aus (CSS: .bonatea-fremd-toggle).
     Ohne Code ginge es auch: den Wert in der Judge.me-App wieder
     leeren, dann entsteht der zweite Link gar nicht erst. */
  var FREMD_LABEL = /^(mehr lesen|mehr anzeigen|weniger anzeigen|weniger lesen|alles lesen|read more|show more|show less|read less)$/i;

  var groessenBeobachter = null;        /* ResizeObserver, falls vorhanden */

  /* ---------- Messen ----------------------------------------- */

  /* Die echte Zeilenhöhe des Absatzes. Judge.me setzt auf Mobile eine
     andere Schriftgröße als auf Desktop – deshalb wird gemessen und
     nicht mit einem festen em-Wert gerechnet. So sind es auf jedem
     Gerät exakt MAX_LINES Zeilen. */
  function zeilenhoehe(el) {
    var stil = window.getComputedStyle(el);
    var lh = parseFloat(stil.lineHeight);
    if (!lh) {                          /* line-height: normal */
      lh = parseFloat(stil.fontSize) * 1.4;
    }
    return lh || 22.4;
  }

  /* Eine Messung taugt nur etwas, wenn der Text wirklich im Layout
     steht: im Dokument, sichtbar (Breite und Höhe > 0) und mit Inhalt.
     Alles andere heißt "noch nicht so weit" – und wird bewusst NICHT
     als erledigt vermerkt. */
  function messbar(el) {
    if (!el.isConnected) { return false; }
    if (!el.textContent || !el.textContent.trim()) { return false; }
    var rechteck = el.getBoundingClientRect();
    return rechteck.width > 0 && rechteck.height > 0;
  }

  /* ---------- Aufklapp-Link ---------------------------------- */

  /* Suchbereich für Aufräumarbeiten: das Elternelement des Textes.
     Dort liegt unser Link immer (er wird als Geschwister eingefügt),
     und die Suche bleibt sicher innerhalb EINER Bewertung. */
  function bereichVon(body) {
    return body.parentElement;
  }

  /* Unseren Link suchen UND dabei aufräumen – nicht nur direkt hinter
     dem Text schauen. Genau daran sind doppelte Links entstanden: Judge.me
     schiebt nachträglich Elemente zwischen Text und Link (z.B. die
     Bilder einer Bewertung), nextElementSibling war dann nicht mehr
     unser Button und es wurde ein zweiter angelegt.
     Nebenbei wird aufgeräumt: höchstens EIN Link pro Karte, und der
     sitzt direkt hinter dem Text. */
  function linkAufraeumen(body) {
    var bereich = bereichVon(body);
    if (!bereich) { return null; }

    var alle = bereich.querySelectorAll('.' + KLASSE_BTN);
    if (!alle.length) { return null; }

    for (var i = 1; i < alle.length; i++) { alle[i].remove(); }

    var btn = alle[0];
    if (btn.previousElementSibling !== body) {
      body.insertAdjacentElement('afterend', btn);
    }
    return btn;
  }

  /* Judge.mes eigenen Aufklapp-Link in dieser Karte ausblenden. */
  function fremdeToggleAusblenden(body) {
    var bereich = bereichVon(body);
    if (!bereich) { return; }

    var kandidaten = bereich.querySelectorAll('a, button');
    for (var i = 0; i < kandidaten.length; i++) {
      var el = kandidaten[i];
      if (el.classList.contains(KLASSE_BTN)) { continue; }   /* unserer */
      if (el.classList.contains(KLASSE_FREMD)) { continue; } /* schon erledigt */

      var text = (el.textContent || '').trim();
      if (text.length > 20 || !FREMD_LABEL.test(text)) { continue; }

      el.classList.add(KLASSE_FREMD);
    }
  }

  function buttonAnlegen(body) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = KLASSE_BTN;
    btn.textContent = LABEL_MORE;
    btn.setAttribute('aria-expanded', 'false');

    btn.addEventListener('click', function () {
      var offen = body.classList.toggle(KLASSE_OFFEN);
      btn.textContent = offen ? LABEL_LESS : LABEL_MORE;
      btn.setAttribute('aria-expanded', offen ? 'true' : 'false');
    });

    /* als Geschwister NACH dem Text – nicht hinein, der hat
       overflow:hidden und würde den Button verschlucken */
    body.insertAdjacentElement('afterend', btn);
    return btn;
  }

  /* ---------- Kernlogik -------------------------------------- */

  function bewerten(body) {
    if (!messbar(body)) { return; }     /* nichts merken, später erneut */

    /* Gemerkt wird Breite + Textlänge, nicht ein blankes "erledigt".
       Ändert sich eins von beidem (Fenster gedreht, AJAX-Text getauscht),
       wird neu gemessen; sonst ist der Durchlauf ein billiges return. */
    var schluessel = Math.round(body.getBoundingClientRect().width) +
                     ':' + body.textContent.trim().length;
    if (body.dataset.bonateaStand === schluessel) { return; }
    body.dataset.bonateaStand = schluessel;

    var lh = zeilenhoehe(body);
    var grenze = lh * MAX_LINES;

    /* Das CSS kürzt auf diese Höhe. Die Zeilenhöhe braucht es zusätzlich
       für den weichen Auslauf über der letzten Zeile. */
    body.style.setProperty('--bonatea-clamp-zeile', lh + 'px');
    body.style.setProperty('--bonatea-clamp-hoehe', grenze + 'px');

    /* Kürzt Judge.me selbst (widget_review_max_height), sitzt dessen
       max-height als Inline-Style am Element. Das muss weg: sonst messen
       wir die fremd gekürzte Höhe und halten jeden Text für kurz. Ab
       hier gehört die Kürzung uns. */
    if (body.style.maxHeight) { body.style.maxHeight = ''; }

    /* Gemessen wird immer der UNGEKÜRZTE Text – für die Messung die
       Kürzung also kurz aufheben. */
    var warGekuerzt = body.classList.contains(KLASSE_KURZ);
    if (warGekuerzt) { body.classList.remove(KLASSE_KURZ); }
    var volleHoehe = body.getBoundingClientRect().height;
    if (warGekuerzt) { body.classList.add(KLASSE_KURZ); }

    if (volleHoehe > grenze + TOLERANZ) {
      body.classList.remove(KLASSE_FREI);
      body.classList.add(KLASSE_KURZ);
      if (!linkAufraeumen(body)) { buttonAnlegen(body); }
      /* Ein bereits aufgeklappter Text bleibt aufgeklappt: KLASSE_OFFEN
         wird hier nie angefasst. */
    } else {
      /* Passt von allein (kurzer Text, oder breiteres Fenster): Kürzung
         und Link weg, damit kein funktionsloser Link stehenbleibt.
         KLASSE_FREI hebt zusätzlich eine fremde Kürzung auf – sonst
         stünde ein abgeschnittener Text ohne Aufklapp-Link da, und
         genau das soll hier nie passieren. */
      body.classList.remove(KLASSE_KURZ);
      body.classList.remove(KLASSE_OFFEN);
      body.classList.add(KLASSE_FREI);
      var btn = linkAufraeumen(body);
      if (btn) { btn.remove(); }
    }
  }

  function durchgehen() {
    var texte = document.querySelectorAll('.jdgm-rev__body');
    for (var i = 0; i < texte.length; i++) {
      /* observe() auf ein bereits beobachtetes Element ist unschädlich. */
      if (groessenBeobachter) { groessenBeobachter.observe(texte[i]); }

      /* Aufräumen läuft bei JEDEM Durchlauf, nicht nur beim Messen:
         Judge.me schiebt seinen eigenen Link und die Bewertungsbilder
         auch dann noch nach, wenn wir längst gemessen haben. bewerten()
         kommt in dem Fall sofort zurück und käme nie dazu. */
      linkAufraeumen(texte[i]);
      fremdeToggleAusblenden(texte[i]);

      bewerten(texte[i]);
    }
  }

  /* Entprellt, damit das Einfügen der Buttons nicht sofort den nächsten
     Durchlauf auslöst. Ein Durchlauf ohne Änderung kostet fast nichts,
     weil bewerten() über den gemerkten Stand sofort zurückkommt. */
  var geplant = false;
  function planen() {
    if (geplant) { return; }
    geplant = true;
    window.requestAnimationFrame(function () {
      geplant = false;
      durchgehen();
    });
  }

  function start() {
    /* Feuert, sobald ein Absatz eine Größe bekommt – also auch dann, wenn
       Judge.me das Widget erst spät einblendet – und bei jeder
       Breitenänderung. Ohne ResizeObserver tragen die Events unten. */
    if (typeof ResizeObserver !== 'undefined') {
      groessenBeobachter = new ResizeObserver(planen);
    }

    planen();

    /* childList: Judge.me lädt das Widget asynchron nach und tauscht beim
       Blättern die komplette Liste per AJAX aus.
       class/style: Judge.me blendet das fertige Widget per Klasse ein. Das
       ist KEINE Änderung am Inhalt – ohne diesen Filter bliebe sie
       unbemerkt, und genau daran ist die erste Fassung gescheitert. */
    new MutationObserver(planen).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    /* Nach dem vollständigen Laden und nach dem Webfont-Wechsel bricht der
       Text anders um – dann noch einmal nachmessen. */
    window.addEventListener('load', planen);
    window.addEventListener('resize', planen);
    window.addEventListener('orientationchange', planen);

    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(planen).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
